import "./GlobalLoader.css";
export default function GlobalLoader() {
  return (
    <div className="global-loader">
      <div className="loader-circle"></div>
    </div>
  );
}
